import { Component, Vue } from 'vue-property-decorator';
@Component
export default class I18nMixin extends Vue {
  public $getContent($key: string) {
    return this.$t($key);
  }
}
